import { usePermissionStore, PermissionModule, PermissionAction } from '../core/stores/permissionStore'
import { useAuthStore } from '../core/stores/authStore'

/**
 * Hook per verificare se l'utente ha un permesso specifico.
 * SuperAdmin ha sempre tutti i permessi. Admin ha sempre tutti i permessi.
 */
export function usePermission(module: PermissionModule, action: PermissionAction): boolean {
  const user = useAuthStore((s) => s.user)
  const hasPermission = usePermissionStore((s) => s.hasPermission)

  if (!user) return false
  if (user.user_type === 'superadmin') return true
  if (user.role === 'admin') return true

  return hasPermission(module, action)
}

/**
 * Hook per verificare se l'utente è il proprietario di un'entità.
 * Admin bypassa sempre l'ownership check.
 */
export function useIsOwner(ownerId: string | null | undefined): boolean {
  const user = useAuthStore((s) => s.user)
  if (!user) return false
  if (user.role === 'admin') return true
  if (!ownerId) return true // Entità senza owner → chiunque
  return ownerId === user.user_id
}

/**
 * Hook combinato: permesso + ownership.
 * Per operazioni di modifica che richiedono entrambi.
 */
export function useCanEdit(module: PermissionModule, ownerId: string | null | undefined): boolean {
  const hasEdit = usePermission(module, 'edit')
  const isOwner = useIsOwner(ownerId)
  return hasEdit && isOwner
}
